export default __webpack_public_path__ + "static/media/lindasol.95eb0134.png";